export const stepConfig = [
  {target: '.createCourseButton', key: 'createCourseButton'},
  {target: '.CourseCardContainer', key: 'courseCardContainer'},
  {target: '.courseCardInfoRightBox', key: 'courseCardInfoRightBox'},
];
